"use client";

export default function TermsConditions() {
  return (
    <div className="relative min-h-screen bg-white py-32">

      <style jsx global>{`
        #global-contact-form { display: none !important; }
      `}</style>

      {/* Background decorative lines */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="w-full origin-center transform-gpu absolute -left-[40%] top-0">
          <div className="h-[1px] bg-gray-300 rotate-[296.7deg] w-[200%]" />
        </div>
        <div className="w-full origin-center transform-gpu absolute -right-[40%] top-0">
          <div className="h-[1px] bg-gray-300 rotate-[296.8deg] w-[200%]" />
        </div>
      </div>

      <div className="custom-container mx-auto px-4 relative z-10 max-w-7xl">

        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold text-[#272d57] tracking-tight">
            Terms & Conditions
          </h1>
          <p className="text-gray-500 mt-2">Last updated: June 01, 2025</p>
        </div>

        {/* Content */}
        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed border shadow-[0_4px_54px_0_rgba(0,0,0,0.05)] border-gray-100 p-12 rounded-lg">

          {/* INTRO */}
          <p>
            Welcome to <strong>Make My Brand Labs!</strong>

          </p>
          <p className="my-2">
            These Terms and Conditions outline the rules and regulations for the use of <strong>Make My Brand Labs’</strong> Website, located at
            <a
              href="https://makemybrandlabs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-blue-600 hover:underline"
            >
              {" "}https://makemybrandlabs.com
            </a>.
          </p>

          <p>
            By accessing this Website, we assume you accept these Terms and Conditions in full. Do not continue to use <strong>Make My Brand Labs</strong> if you do not agree to all the terms and conditions stated on this page.

          </p>

          {/* TERMINOLOGY */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            1. Terminology
          </h2>

          <p>The following terminology applies to these Terms and Conditions, Privacy Statement, and Disclaimer Notice, and all Agreements:          </p>

          <ul className="list-disc pl-6 space-y-2 my-4">
            <li><strong>“Client”, “You”, “Your”</strong> – refers to the user accessing our Website.</li>
            <li><strong>“The Company”, “We”, “Us”, “Our”</strong> – refers to MMB Digital Labs (Make My Brand Labs).</li>
            <li><strong>“Party”, “Parties”</strong> – refers to both You and Us.</li>
          </ul>

          <p>
            All terms refer to the offer, acceptance, and consideration of payment necessary to undertake our services to the Client in the most appropriate manner for the purpose of meeting the Client’s needs in respect of the provision of the Company’s stated services, in accordance with the applicable laws of India.
            India.
          </p>

          {/* COOKIES */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            2. Cookies
          </h2>

          <p>
            We use cookies to enhance user experience. By accessing <strong>Make My Brand Labs</strong>, you agree to use cookies in agreement with our Privacy Policy.

          </p>

          <p>
            Cookies are used by most interactive websites to retrieve user details for each visit. Our Website uses cookies to enable functionality in certain areas, making it easier for visitors. Some of our affiliate or advertising partners may also use cookies.

          </p>

          {/* LICENSE */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            3. License
          </h2>

          <p>
            Unless otherwise stated, <strong>MMB Digital Labs (Make My Brand Labs)</strong> and/or its licensors own the intellectual property rights for all material on this Website. All intellectual property rights are reserved.

          </p>

          <p>You may access this Website for your personal use subject to restrictions set in these Terms and Conditions.
          </p>

          <p><strong>You must not:</strong></p>

          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Republish material from <strong>MMB Digital Labs </strong>  </li>
            <li>Sell, rent, or sub-license material <strong>MMB Digital Labs </strong> </li>
            <li>Reproduce, duplicate, or copy content <strong>MMB Digital Labs </strong> </li>
            <li>Redistribute Website content <strong>MMB Digital Labs </strong> </li>
          </ul>

          <p className="my-2">This Agreement begins on the date you access the Website.</p>

          {/* HYPERLINKING */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            4. Hyperlinking to Our Content
          </h2>

          <p>The following organizations may link to our Website without prior written approval:
          </p>

          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Government agencies</li>
            <li>Search engines</li>
            <li>News organizations</li>
            <li>Online directory distributors (in the same manner as they hyperlink to other listed businesses)</li>
          </ul>

          <p>We may consider and approve other link requests from:
          </p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Commonly known business or consumer information sources</li>
            <li>Community websites</li>
            <li>Non-profit organizations and associations</li>
            <li>Online directory distributors</li>
            <li>Internet portals</li>
            <li>Accounting, legal, and consulting firms</li>
            <li>Educational institutions and trade associations</li>
          </ul>

          <p>Approved organizations may hyperlink to our Website using:

          </p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Our corporate name;</li>
            <li>The uniform resource locator (URL); or</li>
            <li>Any other appropriate description of our Website.</li>
          </ul>

          <p><strong>No use of Make My Brand Labs’ logo or other artwork will be allowed for linking without a trademark license agreement.
          </strong></p>

          {/* IFRAMES */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            5. iFrames
          </h2>

          <p>
            Without prior approval and written permission, you may not create frames around our Webpages that alter our Website’s visual presentation or appearance.
          </p>

          {/* CONTENT LIABILITY */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            6. Content Liability
          </h2>

          <p>
            We shall not be held responsible for any content appearing on your website. You agree to defend and protect us against all claims arising from your website.
          </p>

          {/* RESERVATION OF RIGHTS */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            7. Reservation of Rights
          </h2>

          <p>
            We reserve the right to request the removal of all links or any particular link to our Website at any time. You agree to immediately remove all links upon request.
          </p>
          <p className="my-2">We also reserve the right to amend these terms and conditions and our linking policy at any time. By continuing to link to our Website, you agree to be bound by and follow these linking terms and conditions.
          </p>

          {/* REMOVAL REQUESTS */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            8. Removal of Links From Our Website
          </h2>

          <p>
            If you find any link on our Website offensive for any reason, you are free to contact and inform us at any time. We will consider requests to remove links, but we are not obligated to do so or respond directly.

          </p>
          <p className="my-2">We do not guarantee that the information on this Website is correct, complete, or up to date. We do not warrant that the Website will remain available or that the material will always be current.

          </p>

          {/* DISCLAIMER */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            9. Disclaimer
          </h2>

          <p>
            To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our Website and its use.
          </p>

          <p>Nothing in this disclaimer will:</p>

          <ul className="list-disc pl-6 my-4">
            <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation</li>
            <li>Modify any of our or your liabilities in ways not permitted under applicable law</li>
            <li>Exclude any of our or your liabilities that may not be excluded under applicable law</li>
          </ul>


          <p className="my-2">
            The limitations and prohibitions of liability set forth in this section and elsewhere in this disclaimer:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li>Modify any of our or your liabilities in ways not permitted under applicable law</li>
            <li> Govern all liabilities arising under this disclaimer, including liabilities in contract, tort, or breach of statutory duty.
              Are subject to the preceding paragraph; and  </li>
          </ul>
          <p className="py-5">
            As long as the Website and the information and services on the Website are provided free of charge, we will not be liable for any loss or damage of any kind.
          </p>

          {/* GOVERNING LAW */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-3">
            10. Governing Law
          </h2>

          <p>
            These Terms and Conditions are governed by and construed in accordance with the laws of India, and you submit to the non-exclusive jurisdiction of the courts located in Mohali, Punjab for the resolution of any disputes.

          </p>

          {/* CONTACT */}
          <h2 className="text-2xl font-semibold text-[#272d57] mt-12 mb-4">
            Contact Us
          </h2>

          <p>If you have any questions or concerns about these Terms and Conditions, please contact us:
          </p>

          <p className="mt-2">
            <strong>MMB Digital Labs (Make My Brand Labs)</strong><br />
            📧 Email:
            <a href="mailto:info@makemybrandlabs.com" className="text-blue-600 hover:underline">
              info@makemybrandlabs.com
            </a>
            <br />
            🌐 Website:
            <a
              href="https://makemybrandlabs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              makemybrandlabs.com
            </a>
          </p>

        </div>
      </div>
    </div>
  );
}
